import { store } from "@/vuex/store.js"
import { setHeader,axiosGet, axiosPost,axiosPut, axiosDelete } from "../options/header"


export default {
  async getAllStrankeProtustranke() {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/osoba/fizicka",{
         credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },
  getAllIndustries() {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/osoba/industries",
      {
         credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },
  async getAllTipoviIzvora() {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/osoba/tipovi-izvora",
      {
         credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },
  async getSingleStrankaProtustranka(oib) {
    let accessToken = store.state.aToken

    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/osoba/fizicka/" + oib, {
        params: {
          accessToken,
        },
         credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },
  async getPhisPersCommunication(oib) {
    let accessToken = store.state.aToken

    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/osoba/fizicka/" + oib + '/communication', {
        params: {
          accessToken,
        },
         credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },
  getEditPhisEntity(oib) {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/osoba/fizicka/" + oib + "/edit",
      {
         credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },
  updateFizicka(osoba, oib) {
    try {
      return axiosPut(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/osoba/fizicka/" + oib, {
        params: {
          osoba,
        },
         credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },
  updatePravna(formData) {
    try {
      return axiosPut(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/osoba/pravna", formData, {
         credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },
  insertFizicka(osoba) {
    try {
      return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/osoba/fizicka", {
        params: {
          osoba,
        },
         credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },
  insertPravna(formData) {
    try {
      return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/osoba/pravna", formData, {
         credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },
  quickinsertFizicka(osoba) {
    try {
      return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/osoba/fizicka/quick", {
        params: {
          osoba,
        },
         credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },
  quickinsertPravna(osoba) {
    try {
      return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/osoba/pravna/quick", {
        params: {
          osoba,
        },
         credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },
  async getAllOsobe(personType, src_type=0) {

    // let accessToken = store.state.aToken 
    // // console.log(accessToken)
    // console.log(process.env.VUE_APP_SECRET_KEY.toString() === '8y/B?E(G+KbPeShVmYq3t6w9z$C&F)J@McQfTjWnZr4u7x!A%D*G-KaPdRgUkXp2')
    // var bytes  = CryptoJS.AES.encrypt(accessToken, '8y/B?E(G+KbPeShVmYq3t6w9z$C&F)J@McQfTjWnZr4u7x!A%D*G-KaPdRgUkXp2');
    // console.log(bytes)

    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/osoba/all", {
        params: {
          personType,
          src_type
        },
         credentials: true

      });
    } catch (err) {
      console.log(err);
    }
  },
  getAllFizLeg() {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/osoba/fiz-leg",{
         credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },
  async getOdvjetnik(oib) {
    let accessToken = store.state.aToken
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/osoba/law/" + oib, {
        params: {
          accessToken,
        },
         credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },
  async getOdvjetnikShort(oib) {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/osoba/law/" + oib + "/short", {
         credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },
  async getCasesBySource(oib) {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/osoba/law/" + oib + "/get-cases-by-source", {
         credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },
  async editOdvjetnik(uid, person) {
    let accessToken = store.state.aToken
    try {
      return axiosPut(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/osoba/law/" + uid, {
        params: {
          accessToken,
          person
        },
         credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },
  async getOdvjetnikComunication(oib) {
    let accessToken = store.state.aToken
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/osoba/law/" + oib + "/comunication", {
        params: {
          accessToken,
        },
         credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },
  async getLegBodyComunication(oib) {
    let accessToken = store.state.aToken
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/osoba/leg-body/" + oib + "/comunication", {
        params: {
          accessToken,
        },
         credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },
  async getSluzbena(oib) {
    let accessToken = store.state.aToken
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/osoba/leg/" + oib, {
        params: {
          accessToken,
        },
         credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },
  async getPravna(oib) {
    let accessToken = store.state.aToken
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/osoba/pravna/" + oib, {
        params: {
          accessToken,
        },
         credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },
  async getPravnaComunication(oib) {
    let accessToken = store.state.aToken
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/osoba/pravna/" + oib + "/comunication", {
        params: {
          accessToken,
        },
         credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },
  searchAll(srch_txt) {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/osoba/search", {
        params: {
          srch_txt,
        },
         credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },
  getAllStatusi() {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/osoba/statusi",{
         credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },
  getAllProjectStatuses() {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/osoba/statusi-project",{
         credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },



  //legal body-s START

  async get_all_legal_body() {
    let accessToken = store.state.aToken
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/legal-body", {
        params: {
          accessToken,
        },
         credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },

  get_all_legal_body_short() {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/legal-body/short", {
         credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },

  create_legal_body(leg_body) {
    try {
      return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/legal-body", {
        params: {
          leg_body,
        },
         credentials: true
      });

    } catch (err) {
      console.log(err);
    }
  },
  update_legal_body(leg_body, uid) {
    try {
      return axiosPut(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/legal-body/" + uid, {
        params: {
          leg_body,
        },
         credentials: true
      });

    } catch (err) {
      console.log(err);
    }
  },

  async get_single_legal_body(uid) {
    let accessToken = store.state.aToken
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/legal-body/" + uid, {
        params: {
          accessToken,
        },
         credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },
  getIzvod(accessToken, attach_id) {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/osoba/pravna/" + attach_id + '/sud-reg-izvod', {
        params: {
          
        }
      });
    } catch (err) {
      console.log(err);
    }
  },
  sudRegAPICall(oib) {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/osoba/pravna/" + oib + '/sud-reg-izvod-api', {
        responseType: "arraybuffer",
        encodeURI: "UTF-8",
        headers: setHeader().headers,
         credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },
  //legal body-s END
  deleteFizicka(uid) {
    try {
      return axiosDelete(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/osoba/fizicka/" + uid, {
         credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },
  deletePravna(uid) {
    try {
      return axiosDelete(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/osoba/pravna/" + uid, {
         credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },
  deleteSluzbena(uid) {
    try {
      return axiosDelete(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/legal-body/" + uid, {
         credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },

}